// extracted by mini-css-extract-plugin
export default {"kpiGrid":"DashboardSkeleton_kpiGrid__gg9XG","listContainer":"DashboardSkeleton_listContainer__B4RzM"};